/* HLT ツアー一覧ページ: 検索・カテゴリチップの動作
 * カスタマイザーのセクション再描画(shopify:section:load)後も再初期化する。 */
(function () {
  'use strict';

  function go(q) {
    q = (q || '').trim();
    if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  }

  function init(root) {
    root = root || document;

    root.querySelectorAll('[data-hlt-search]').forEach(function (inp) {
      if (inp.dataset.hltBound) return;
      inp.dataset.hltBound = '1';
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          go(inp.value);
        }
      });
    });

    var btn = root.querySelector('[data-hlt-search-btn]');
    if (btn && !btn.dataset.hltBound) {
      btn.dataset.hltBound = '1';
      btn.addEventListener('click', function () {
        var scope = btn.parentElement || document;
        var inp = scope.querySelector('[data-hlt-search]') || document.querySelector('[data-hlt-search]');
        if (inp) go(inp.value);
      });
    }

    root.querySelectorAll('[data-hlt-chip]').forEach(function (chip) {
      if (chip.dataset.hltBound) return;
      chip.dataset.hltBound = '1';
      chip.addEventListener('click', function () {
        var label = (chip.textContent || '').trim();
        if (label) go(label);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
